module.exports = __webpack_public_path__ + "static/media/hardware3.483e25ee.png";